import { AVAILABLE_LANGUAGES, DEFAULT_LANG } from 'constants/i18n'
import { Languages } from './enum'

export const getLanguageFromPath = () => {
    const { pathname } = window.location
    const languageFromPath = pathname.split('/')[1]

    if (AVAILABLE_LANGUAGES.includes(languageFromPath))
        return languageFromPath as Languages
    return DEFAULT_LANG
}

export const getLanguageFromLocale = (locale: string) => {
    if (AVAILABLE_LANGUAGES.includes(locale)) return locale as Languages
    return DEFAULT_LANG
}
